define('views/blocks/CashOnDeliveryView',['jquery', 'underscore', 'backbone', 'router', 'app', 'ApiRequest', 'template!blocks/payments/cash', 'string'],

    function ($, _, Backbone, router, app, ApiRequest, cashTemplate, S) {

        var view, paymentMethod;

        var CashOnDeliveryView = Backbone.View.extend({
            //
            className: 'CashOnDelivery', //
            events: {

                'change input[name=return_money]': 'ChangeReturnMoney',

            }, initialize: function (options) {
                view = this;
                view.paymentMethod = options.paymentMethod;
            }, render: function () {

                view.$el.html(cashTemplate({
                    cart: app.getCart(),
                }));
                view.delegateEvents();

            },
             str_replace :function(search, replace, subject, count) {

            var i = 0,
                j = 0,
                temp = '',
                repl = '',
                sl = 0,
                fl = 0,
                f = [].concat(search),
                r = [].concat(replace),
                s = subject,
                ra = Object.prototype.toString.call(r) === '[object Array]',
                sa = Object.prototype.toString.call(s) === '[object Array]';
            s = [].concat(s);
            if (count) {
                this.window[count] = 0;
            }

            for (i = 0, sl = s.length; i < sl; i++) {
                if (s[i] === '') {
                    continue;
                }
                for (j = 0, fl = f.length; j < fl; j++) {
                    temp = s[i] + '';
                    repl = ra ? (r[j] !== undefined ? r[j] : '') : r[0];
                    s[i] = (temp).split(f[j]).join(repl);
                    if (count && s[i] !== temp) {
                        this.window[count] += (temp.length - s[i].length) / f[j].length;
                    }
                }
            }
            return sa ? s : s[0];
        },
            ChangeReturnMoney: function () {
                var view = this,
                    inputVal = view.$('input[name=return_money]').val(),
                    typeOfInput = typeof(inputVal).toLowerCase(),
                    return_money;
                switch(typeOfInput){
                    case 'number':
                    case 'string':
                        inputVal = S(inputVal).trim().replace(',','.');
                        return_money = inputVal.toFloat(2);
                        inputVal = inputVal.s;
                        break;
                    default :
                        inputVal = '';
                        return_money = 0;
                        break;
                }
                if (_.isNaN(return_money) || !/^\d+[,.]?\d{0,2}$/.test(inputVal)) {
                    app.alert(app.t("%s n'est pas une somme valide, merci de saisir un nombre", 'Cart', inputVal));
                    return_money = 0;
                    view.$('input[name=return_money]').val('');
                }
                view.paymentMethod.options.return_money = return_money;

            }, submit: function (e) {
                e.preventDefault();
            }

        });

        return CashOnDeliveryView;
    });
